import {
  Input,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React from "react";
import { updateDecimalInputOnState } from "../../utilities/tp-validations";
import TableStyleUtility from "../TransactionUtility/connected-table-style-utility-bar";

function RetailAccordion(props) {
  const compBids = parseInt(props.transactions.compBids, 10);

  return (
    <TableContainer variant="outlined">
      <Table
        striped
        sx={{ minWidth: 650 }}
        sx={{ minWidth: 650 }}
        aria-label="simple table"
        size={"small"}
      >
        <TableStyleUtility />
        <TableBody>
          <TableRow hover key="Cash Down" id={"Cash Down"}>
            <TableCell>
              <InputLabel>{props.texts.CASH_DOWN}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdCashDown"
                readOnly={props.actionType.action === "view"}
                value={
                  props.transactions.bids[0].paymentType.cashDown
                }
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "cashDown",
                    "JD",
                    props.setBidsPaymentTypeTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compCashDown"
                    readOnly={props.actionType.action === "view"}
                    value={
                      props.transactions.bids[index + 1].paymentType
                        .cashDown
                    }
                    onChange={(e) => {
                      updateDecimalInputOnState(
                        e.target.value,
                        8,
                        "cashDown",
                        `C${index + 1}`,
                        props.setBidsPaymentTypeTextValue
                      );
                      props.calculateSpreadAndMargin(props);
                    }}
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow hover key="Finance Rate" id={"Finance Rate"}>
            <TableCell>
              <InputLabel>{props.texts.FINANCE_RATE}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdFinanceRate"
                readOnly={props.actionType.action === "view"}
                value={
                  props.transactions.bids[0].paymentType.finRate
                }
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    5,
                    "finRate",
                    "JD",
                    props.setBidsPaymentTypeTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compFinanceRate"
                    readOnly={props.actionType.action === "view"}
                    value={
                      props.transactions.bids[index + 1].paymentType.finRate
                    }
                    onChange={(e) => {
                      updateDecimalInputOnState(
                        e.target.value,
                        5,
                        "finRate",
                        `C${index + 1}`,
                        props.setBidsPaymentTypeTextValue
                      );
                      props.calculateSpreadAndMargin(props);
                    }}
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow hover key="Months Financed" id={"Months Financed"}>
            <TableCell>
              <InputLabel>{props.texts.MON_FINANCED}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdMonthsFinanced"
                readOnly={props.actionType.action === "view"}
                value={
                  props.transactions.bids[0].paymentType.noOfMonths
                }
                onChange={(e) => {
                  if (e.target.value.match("^[\\d]*$")) {
                    updateDecimalInputOnState(
                      e.target.value,
                      2,
                      "noOfMonths",
                      "JD",
                      props.setBidsPaymentTypeTextValue
                    );
                  }
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compMonthsFinanced"
                    readOnly={props.actionType.action === "view"}
                    value={
                      props.transactions.bids[index + 1].paymentType
                        .noOfMonths
                    }
                    onChange={(e) => {
                      if (e.target.value.match("^[\\d]*$")) {
                        updateDecimalInputOnState(
                          e.target.value,
                          2,
                          "noOfMonths",
                          `C${index + 1}`,
                          props.setBidsPaymentTypeTextValue
                        );
                      }
                      props.calculateSpreadAndMargin(props);
                    }}
                  />
                </TableCell>
              ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RetailAccordion;
